module.exports = __webpack_public_path__ + "img/Mancala-ai-logo.a94a40b4.png";